const CloseIcon = (props) => (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props} 
	>
		<path d="M3 3L11 11M3 11L11 3" strokeWidth="2"/>
	</svg>
)

export default CloseIcon